import { Svg } from '../../utils/IconBase';
import { IconProps } from '../../utils/icon';

const IconJournalCollectLine = ({ width, height, fill = 'currentColor', ...props }: IconProps) => {
  return (
    <Svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fill={fill}
        d="M9.458 11.184V5.548A4.07 4.07 0 0 0 6.993 6.92c-.662.755-1.028 1.614-1.097 2.58H5c-.69 0-1.28.244-1.768.732a2.415 2.415 0 0 0-.732 1.771c0 .692.244 1.28.732 1.767.488.486 1.077.73 1.768.73h10.5c.56 0 1.033-.194 1.42-.58.386-.385.58-.857.58-1.416a1.94 1.94 0 0 0-.58-1.422 1.925 1.925 0 0 0-1.42-.583H14V9a3.09 3.09 0 0 0-.354-1.433 3.916 3.916 0 0 0-1.021-1.234V5.077c.752.39 1.35.936 1.793 1.638A4.19 4.19 0 0 1 15.083 9v.417h.257c.892-.043 1.655.237 2.29.84.636.603.953 1.344.953 2.222 0 .874-.302 1.61-.907 2.208a2.986 2.986 0 0 1-2.176.896H5c-1 0-1.846-.355-2.541-1.065a3.532 3.532 0 0 1-1.042-2.563c0-1.033.36-1.912 1.083-2.636.722-.724 1.583-1.041 2.582-.95.23-1.086.787-2.001 1.673-2.746.885-.745 1.786-1.118 2.703-1.118.295 0 .55.095.763.286.214.19.32.442.32.756v5.638l1.004-1.012a.555.555 0 0 1 .39-.177.504.504 0 0 1 .384.17c.12.12.18.249.18.386s-.06.266-.18.387l-1.857 1.857a.64.64 0 0 1-.466.202.62.62 0 0 1-.461-.205L7.681 10.94a.5.5 0 0 1-.163-.387.578.578 0 0 1 .184-.387.53.53 0 0 1 .39-.177c.14.003.268.065.384.185l.982 1.011Z"
      />
    </Svg>
  );
};

export default IconJournalCollectLine;
